export const applicationShellKey = Symbol() as InjectionKey<globalThis.Ref<boolean>>;
